const normalizeName = (value) => String(value || "").normalize("NFC").trim().replace(/\s+/g, " ").toLowerCase();

export const getIncomingPatientNameKeys = (patient) => [
  [patient.firstnameTh, patient.lastnameTh],
  [patient.firstnameEn, patient.lastnameEn],
].map((parts) => parts.map(normalizeName))
  .filter(([first, last]) => first && last)
  .map((parts) => JSON.stringify(parts));

// Match complete first/last name pairs, never a shared first name alone.
// Document IDs are the canonical Company HNs used by patient pages.
export const findIncomingPatientNameMatches = (incoming, patientDocuments) => {
  const names = new Set(getIncomingPatientNameKeys(incoming));
  return patientDocuments.filter((patient) => getIncomingPatientNameKeys(patient).some((name) => names.has(name)))
    .map((patient) => ({ ...patient, hn: patient.id }))
    .sort((a, b) => a.hn.localeCompare(b.hn));
};
